var o={cdn:"https://cdn.jcu.edu.au/cookbook/3.2"};export{o as default};
//# sourceMappingURL=config.js.map
